import { NavLink } from "react-router-dom";
import clsx from "clsx";

export type NavItem = {
  to: string;
  label: string;
  end?: boolean;
};

const NAV_ITEMS: NavItem[] = [
  { to: "/research-jobs", label: "Research Jobs", end: true },
  { to: "/hotels", label: "Pipeline", end: true },
  { to: "/approvals", label: "Approvals" },
  { to: "/chat", label: "Chat" },
  { to: "/settings", label: "Settings" },
];

type SidebarProps = {
  open: boolean;
  onClose: () => void;
};

export function Sidebar({ open, onClose }: SidebarProps) {
  return (
    <>
      <div
        className={clsx(
          "fixed inset-0 z-40 bg-gray-900/30 lg:hidden",
          open ? "opacity-100" : "pointer-events-none opacity-0",
        )}
        aria-hidden={!open}
        onClick={onClose}
      />

      <aside
        id="sidebar"
        className={clsx(
          "fixed top-0 left-0 z-40 flex h-[100dvh] w-64 shrink-0 flex-col border-r border-gray-200 bg-white p-4 lg:static lg:translate-x-0",
          open ? "translate-x-0" : "-translate-x-64",
        )}
      >
        <div className="mb-8 flex items-center justify-between px-2">
          <NavLink
            to="/research-jobs"
            className="text-lg font-semibold text-gray-800"
            onClick={onClose}
          >
            CaraGo
          </NavLink>
          <button
            type="button"
            className="text-gray-500 lg:hidden"
            onClick={onClose}
            aria-label="Sidebar schließen"
          >
            ✕
          </button>
        </div>

        <nav aria-label="Hauptnavigation">
          <p className="mb-2 px-3 text-xs font-semibold tracking-wide text-gray-400 uppercase">
            App
          </p>
          <ul className="space-y-1">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={onClose}
                  className={({ isActive }) =>
                    clsx(
                      "block truncate rounded-lg px-3 py-2 text-sm font-medium",
                      isActive
                        ? "bg-violet-50 text-violet-700"
                        : "text-gray-700 hover:bg-gray-50",
                    )
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
}
